import { FC, useCallback, useContext, useEffect, useMemo } from "react";

import { FormInstance } from "antd"
import { SearchOutlined } from "@ant-design/icons";

import dayjs from "dayjs";

import { InputFactory } from "../../../../../../shared/components";
import { InputFactoryProp } from "../../../../../../shared/interfaces";
import { SavedAndSentPreLiquidationsContext } from "../../contexts/SavedAndSentPreLiquidations";

import { COLORS } from "../../../../../../config/themes/colors";
import { PreLiquidationsFilterForm } from "../../interfaces";
import { statesPreLiquidationsFilterForm } from "../../utils/mocks";
import { dateIsBetween } from "../../../../../../shared/utils";

interface PreLiquidationsFilterProps {
    filterForm:             FormInstance<PreLiquidationsFilterForm>;
    isSavedPreliquidations: boolean;
};

export const PreLiquidationsFilter: FC<PreLiquidationsFilterProps> = ({ filterForm, isSavedPreliquidations = false }) => {

    const {
        initialDatasourceSavedPreliquidationsTable,
        initialDatasourceSentPreliquidationsTable,
        setDatasourceSavedPreliquidationsTable, 
        setDatasourceSentPreliquidationsTable 
    } = useContext(SavedAndSentPreLiquidationsContext)

    const inputsFilter: InputFactoryProp[] = useMemo(() => [
        {
            element: 'input',
            type: 'number',
            placeHolder: 'Número',
            icon: <SearchOutlined style={{ color: COLORS.neutrals[50] }} />,
            name: 'preliquidationNumber',
        },
        {
            element: 'date',
            name: 'preliquidationDate',
        }
    ], []);

    const initialStateFilters = useMemo(() => ({
        preliquidationNumber: '',
        preLiquidationState: undefined,
        preliquidationDate: [],
    }), []);

    const onFilterPreliquidations = useCallback(() => {
        const { 
            preLiquidationState, 
            preliquidationNumber, 
            preliquidationDate 
        } = filterForm.getFieldsValue();

        const stateSelected = statesPreLiquidationsFilterForm.find(
            el => el.value === preLiquidationState
        )?.label;

        const dateFrom =  preliquidationDate[0] ? dayjs(preliquidationDate[0]).format('YYYY-MM-DD') : undefined;
        const dateTo = preliquidationDate[1] ? dayjs(preliquidationDate[1]).format('YYYY-MM-DD') : undefined;

        const filteredPreliquidations = (
            isSavedPreliquidations 
                ? initialDatasourceSavedPreliquidationsTable 
                : initialDatasourceSentPreliquidationsTable
        )
        .filter(
            el => (
                ( !preliquidationNumber || el.preliquidationNumber.includes(String(preliquidationNumber))) &&
                ( !stateSelected || el.preliquidationState === stateSelected ) &&
                ( (!dateFrom && !dateTo ) || dateIsBetween(el.preliquidationDate, dateFrom!, dateTo!, 'YYYY-MM-DD'))
            )
        )

        if(isSavedPreliquidations) {
            setDatasourceSavedPreliquidationsTable(filteredPreliquidations);
        } else {
            setDatasourceSentPreliquidationsTable(filteredPreliquidations);
        };
    }, [
        filterForm, 
        isSavedPreliquidations, 
        setDatasourceSavedPreliquidationsTable, 
        setDatasourceSentPreliquidationsTable,
        initialDatasourceSavedPreliquidationsTable,
        initialDatasourceSentPreliquidationsTable,
    ]);

    const onClearPreLiquidationsFilter = useCallback(() => {
        filterForm.setFieldsValue(initialStateFilters);
    }, [filterForm, initialStateFilters])

    useEffect(() => {
        filterForm.setFieldsValue(initialStateFilters);
    }, [filterForm, initialStateFilters]);

    return (
        <InputFactory 
            items={inputsFilter}
            form={filterForm}
            initialState={initialStateFilters}
            onFilter={onFilterPreliquidations}
            onClear={onClearPreLiquidationsFilter}
        />
    )
}
